import React, { useEffect, useMemo } from 'react'
import { Button, Modal, Space, Spin, Table, Tag, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons'
import { useMutationViewPdf } from '../queries'

export default function ViewInvoiceModal({
  open,
  onCancel,
  value = {},
  loading = false,
}) {
  const { mutate: viewPdfInvoice, data, isPending } = useMutationViewPdf('json')

  useEffect(() => {
    if (open) {
      viewPdfInvoice(value)
    }
  }, [open])

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={<div style={{ height: 15 }}></div>}
      title={null}
      closable={false}
      width="min(1200px, 95vw)"
      centered
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 12px',
          borderBottom: '1px solid #f0f0f0',
        }}
      >
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          Xem hóa đơn
        </span>

        <Tooltip title="Làm mới">
          <ReloadOutlined
            style={{
              color: '#578ef8',
              fontSize: 17,
              position: 'absolute',
              top: 37,
              right: 80,
              cursor: 'pointer',
            }}
            onClick={() => {
              viewPdfInvoice({
                invoiceId: value.invoiceId,
                refetch: 1,
              })
            }}
          />
        </Tooltip>
        <Button
          type="text"
          onClick={onCancel}
          icon={<CloseOutlined />}
          title="Đóng"
        />
      </div>

      <div style={{ padding: 16, position: 'relative', height: '80vh' }}>
        {isPending && (
          <div
            style={{
              position: 'absolute',
              inset: 16,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
            }}
          >
            <Spin size="large" tip="Đang tải PDF..." />
          </div>
        )}

        {data && !isPending && (
          <iframe
            src={
              /^https?:\/\//.test(data.fileURL)
                ? data.fileURL
                : `${process.env.REACT_APP_BASE_URL.includes('localhost') ? 'https://v3.vietinvoice.vn' : process.env.REACT_APP_BASE_URL}${data.fileURL}`
            }
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </div>
    </Modal>
  )
}
